// sync-start:coediting-streaming 1375759759 https://github.com/Khan/webapp/blob/master/services/ai-guide/coediting/constants.go
import {getPromptVariable, setPromptVariable} from "@khan/guide-core-helpers";

export const coeditingEditStreamChannel = "coediting/edit";
export const coeditingEventStreamChannel = "coediting/event";
export const coeditingRequestEditCommandName = "coediting/request-edit";
export const coeditingRequestInsertCommandName = "coediting/request-insert";
// sync-end:coediting-streaming

// sync-start:coediting-variables 778152610 https://github.com/Khan/webapp/blob/master/services/ai-guide/coediting/constants.go
export const startedVariable = "coeditStarted";
export const prefixVariable = "coeditPrefix";
export const selectionVariable = "coeditSelection";
export const suffixVariable = "coeditSuffix";
const matchedTriggerVariable = "coeditMatchedTrigger";
const pausedVariable = "coeditPaused";
const initialCompletionFinishedVariable = "coeditInitialCompletionFinished";
const selectedTemplateVariable = "coeditSelectedTemplate";
// sync-end:coediting-variables

export const setCoeditorDocumentVariables = (
    prefix?: string | null,
    selection?: string | null,
    suffix?: string | null,
) => {
    setPromptVariable(prefixVariable, prefix);
    setPromptVariable(selectionVariable, selection);
    setPromptVariable(suffixVariable, suffix);
};

export const unsetCoeditorVariables = () => {
    setPromptVariable(startedVariable, undefined);
    setPromptVariable(matchedTriggerVariable, undefined);
    setPromptVariable(prefixVariable, undefined);
    setPromptVariable(pausedVariable, undefined);
    setPromptVariable(selectionVariable, undefined);
    setPromptVariable(suffixVariable, undefined);
    setPromptVariable(initialCompletionFinishedVariable, undefined);
};

export const getCoeditorVariables = (): {
    prefix: string | null | undefined;
    selection: string | null | undefined;
    started: string | null | undefined;
    suffix: string | null | undefined;
} => ({
    started: getPromptVariable(startedVariable),
    prefix: getPromptVariable(prefixVariable),
    selection: getPromptVariable(selectionVariable),
    suffix: getPromptVariable(suffixVariable),
});

export const setCoeditorStarted = (started: boolean) => {
    if (started) {
        setPromptVariable(startedVariable, "1");
    } else {
        setPromptVariable(startedVariable, null);
    }
};

export const setCoeditorMatchedTrigger = (matchedTrigger: boolean) => {
    if (matchedTrigger) {
        setPromptVariable(matchedTriggerVariable, "1");
    } else {
        setPromptVariable(matchedTriggerVariable, null);
    }
};

export const setCoeditorPaused = (paused: boolean) => {
    if (paused) {
        setPromptVariable(pausedVariable, "1");
    } else {
        setPromptVariable(pausedVariable, null);
    }
};

export const setCoeditorInitialCompletionFinished = () => {
    setPromptVariable(initialCompletionFinishedVariable, "1");
};

export const setCoeditorSelectedTemplate = (templateName: string | null) => {
    setPromptVariable(selectedTemplateVariable, templateName);
};

export const getCoeditorDocumentText = () => {
    return (
        (getPromptVariable(prefixVariable) || "") +
        (getPromptVariable(selectionVariable) || "") +
        (getPromptVariable(suffixVariable) || "")
    );
};
